// extracted by mini-css-extract-plugin
export default {"form":"styles_form__oxQVn","datePicker":"styles_datePicker__HR9HK","item":"styles_item__Bvamh","label":"styles_label__PuVvR"};